<form autocomplete="off" #activityForm="ngForm">
  <div fxLayout="column">
    <div fxLayout="row" fxLayoutAlign="start start" style="margin-bottom: 10px">
      <app-editor-text
        fxFlex="60"
        style="margin-right: 20px"
        name="txtApprovalTitle"
        [(ngModel)]="approvalTitle"
        [config]="{
          isSimpleValue: true,
          isCode: true,
          hintLimit: 50,
          customDisplayName: 'key_title',
          updateOn: updateOnBlure,
          validationKey: 'workflow/approval/approvalTitle'
        }"
        appExpressionValidator
      ></app-editor-text>
      <mat-checkbox
        fxFlex="40"
        [(ngModel)]="disableAutoSelfApproval"
        [ngModelOptions]="{ standalone: true }"
        style="margin-top: 16px"
        >{{ 'key_disableAutoSelfApproval' | translate }}</mat-checkbox
      >
    </div>
    <div fxLayout="row" fxLayoutAlign="start start">
      <app-editor-text
        fxFlex="60"
        style="margin-right: 20px"
        name="txtEmergencyApprovers"
        [(ngModel)]="emergencyApprovers"
        [config]="{
          isSimpleValue: true,
          isCode: true,
          hintLimit: 50,
          customDisplayName: 'key_emergencyApprovers',
          updateOn: updateOnBlure,
          validationKey: 'workflow/approval/emergencyapprovers'
        }"
        appExpressionValidator
      ></app-editor-text>
      <app-editor-text
        fxFlex="40"
        name="txtApprovalThreshold"
        [(ngModel)]="approvalThreshold"
        [config]="{
          isSimpleValue: true,
          isCode: true,
          hintLimit: 50,
          customDisplayName: 'key_threshold',
          updateOn: updateOnBlure,
          validationKey: 'workflow/approval/approvalthreshold'
        }"
        appExpressionValidator
      ></app-editor-text>
    </div>
    <div fxLayout="row" fxLayoutAlign="start center" style="margin-top: 20px">
      <button mat-stroked-button color="primary" (click)="onAddApprovalStage()">
        {{ 'key_addApprovalStage' | translate }}
      </button>
    </div>
    <div
      *ngIf="approversByStage && approversByStage.length > 0"
      class="background-bg-color"
      style="margin-top: 10px; padding: 10px; border-radius: 5px"
    >
      <div
        *ngFor="let stage of stageDic; let i = index"
        fxLayout="row"
        fxLayoutAlign="start start"
        style="margin-bottom: 10px"
      >
        <div
          fxFlex="none"
          class="stage-number accent-bg-color accent-contrast-color"
        >
          {{ i + 1 }}
        </div>
        <app-editor-text
          fxFlex="60"
          style="margin-right: 20px"
          [name]="'txtApproverByStage' + i"
          [(ngModel)]="approversByStage[i]"
          [config]="{
            isSimpleValue: true,
            isCode: true,
            hintLimit: 50,
            customDisplayName: 'key_approver',
            updateOn: updateOnBlure,
            validationKey: 'workflow/approval/approversByStage'
          }"
          appExpressionValidator
        ></app-editor-text>
        <app-editor-text
          fxFlex="40"
          style="margin-right: 20px"
          [name]="'txtDurationByStage' + i"
          [(ngModel)]="durationByStage[i]"
          [config]="{
            isSimpleValue: true,
            isCode: true,
            hintLimit: 50,
            customDisplayName: 'key_durationInDays',
            updateOn: updateOnBlure,
            validationKey: 'workflow/approval/durationbystage'
          }"
          appExpressionValidator
        ></app-editor-text>
        <button
          mat-icon-button
          color="warn"
          fxFlex="none"
          [matTooltip]="'key_delete' | translate"
          style="margin-top: 6px"
          (click)="onRemoveApprovalStage(i)"
        >
          <span class="material-icons-outlined">delete</span>
        </button>
      </div>
    </div>
    <div
      fxLayout="row"
      fxLayoutAlign="start center"
      style="margin-top: 30px; margin-bottom: 10px"
    >
      <app-editor-text
        fxFlex="100"
        style="margin-right: 20px"
        name="txtEtPending"
        [(ngModel)]="pendingApprovalEmailTemplate"
        [config]="{
          isSimpleValue: true,
          isCode: true,
          hintLimit: 100,
          customDisplayName: 'key_emailTemplatePending',
          updateOn: updateOnBlure,
          validationKey: 'workflow/approval/pendingapprovalemailtemplate'
        }"
        appExpressionValidator
      ></app-editor-text>
    </div>
    <div
      fxLayout="row"
      fxLayoutAlign="start center"
      style="margin-top: 10px; margin-bottom: 10px"
    >
      <app-editor-text
        fxFlex="100"
        style="margin-right: 20px"
        name="txtEtEscalation"
        [(ngModel)]="pendingApprovalEscalationEmailTemplate"
        [config]="{
          isSimpleValue: true,
          isCode: true,
          hintLimit: 100,
          customDisplayName: 'key_emailTemplateEscalation',
          updateOn: updateOnBlure,
          validationKey:
            'workflow/approval/pendingapprovalescalationemailtemplate'
        }"
        appExpressionValidator
      ></app-editor-text>
    </div>
    <div
      fxLayout="row"
      fxLayoutAlign="start center"
      style="margin-top: 10px; margin-bottom: 10px"
    >
      <app-editor-text
        fxFlex="100"
        style="margin-right: 20px"
        name="txtEtCompleted"
        [(ngModel)]="completedApprovalEmailTemplate"
        [config]="{
          isSimpleValue: true,
          isCode: true,
          hintLimit: 100,
          customDisplayName: 'key_emailTemplateCompleted',
          updateOn: updateOnBlure,
          validationKey: 'workflow/approval/completedapprovalemailtemplate'
        }"
        appExpressionValidator
      ></app-editor-text>
    </div>
    <div
      fxLayout="row"
      fxLayoutAlign="start center"
      style="margin-top: 10px; margin-bottom: 10px"
    >
      <app-editor-text
        fxFlex="100"
        style="margin-right: 20px"
        name="txtEtApproved"
        [(ngModel)]="approvedApprovalEmailTemplate"
        [config]="{
          isSimpleValue: true,
          isCode: true,
          hintLimit: 100,
          customDisplayName: 'key_emailTemplateApproved',
          updateOn: updateOnBlure,
          validationKey: 'workflow/approval/approvedapprovalemailtemplate'
        }"
        appExpressionValidator
      ></app-editor-text>
    </div>
    <div
      fxLayout="row"
      fxLayoutAlign="start center"
      style="margin-top: 10px; margin-bottom: 10px"
    >
      <app-editor-text
        fxFlex="100"
        style="margin-right: 20px"
        name="txtEtRejected"
        [(ngModel)]="rejectedRequestEmailTemplate"
        [config]="{
          isSimpleValue: true,
          isCode: true,
          hintLimit: 100,
          customDisplayName: 'key_emailTemplateRejected',
          updateOn: updateOnBlure,
          validationKey: 'workflow/approval/rejectedrequestemailtemplate'
        }"
        appExpressionValidator
      ></app-editor-text>
    </div>
    <div
      fxLayout="row"
      fxLayoutAlign="start center"
      style="margin-top: 10px; margin-bottom: 10px"
    >
      <app-editor-text
        fxFlex="100"
        style="margin-right: 20px"
        name="txtEtTimeout"
        [(ngModel)]="timedOutRequestEmailTemplate"
        [config]="{
          isSimpleValue: true,
          isCode: true,
          hintLimit: 100,
          customDisplayName: 'key_emailTemplateTimedOut',
          updateOn: updateOnBlure,
          validationKey: 'workflow/approval/timedoutrequestemailtemplate'
        }"
        appExpressionValidator
      ></app-editor-text>
    </div>
  </div>
</form>
